export default __webpack_public_path__ + "static/media/oportunidade.80c348f9.svg";